<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
              <h3 class="intro-txt">{{ $route.name }}</h3>
            </div> -->

      <page :url="url" :form="form">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.channelId')">
            <el-input
                style="width: 300px"
                v-model="form.channelId"
                :placeholder="$t('message.inputChannelIdOrName')"
                maxlength="20"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.upstream')">
            <el-select v-model="form.upstream" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="item in upstreamList"
                         :key="item.code"
                         :label="item.displayName"
                         :value="item.code"/>
            </el-select>
          </el-form-item>

          <el-form-item
              :label="$t('text.paymentType')"
              prop="productId"
              v-if="ROLE_TYPE.isManager()"
          >
            <el-select
                v-model="form.productId"
                :placeholder="$t('message.chooseOne')"
                :disabled="ROLE_TYPE.isAgent()"
            >
              <el-option key="" :label="$t('option.all')" value=""></el-option>
              <el-option
                  :label="$t('text.collection')"
                  :value="PAYMENT_TYPE_ID_COLLECTION"
              ></el-option>
              <el-option
                  :label="$t('text.disbursement')"
                  :value="PAYMENT_TYPE_ID_PAYMENT"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
              :label="$t('text.transactionStatus')"
              v-if="ROLE_TYPE.isManager()"
          >
            <el-select
                v-model="form.channelStatus"
                :placeholder="$t('message.chooseOne')"
                :disabled="ROLE_TYPE.isAgent()"
            >
              <el-option key="" :label="$t('option.all')" value=""></el-option>
              <el-option
                  :label="$t('merchantStatus.00')"
                  :value="'00'"
              ></el-option>
              <el-option
                  :label="$t('merchantStatus.01')"
                  :value="'01'"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small"
          >{{ $t('text.addChannel') }}
          </el-button>
          <el-button type="primary" @click="openPayeeMatchImport" size="small"
          >{{ $t('text.importPayeeMatchConfig') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column
              prop="channelId"
              width="100px"
              :label="$t('text.channelId')"
              fixed
              align="center"
          >
          </el-table-column>

          <el-table-column prop="channelName" :label="$t('text.channelName')" fixed align="center" width="200px">
          </el-table-column>

          <el-table-column
              prop="productName"
              width="80px"
              :label="$t('text.channelType')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div>{{ row.productId === '110' ? $t('text.collection') : $t('text.disbursement') }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="channelStatus"
              :formatter="$formatter.formatMerState"
              width="80px"
              :label="$t('text.transactionStatus')"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="inStatisticsFlag"
              :formatter="$formatter.formatCommonStatus"
              width="80px"
              :label="$t('text.inStatistics')"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="isOldCustomer"
              :formatter="$formatter.formatNewOldCustomer"
              width="90px"
              :label="$t('text.newOldCustomer')"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="payeeMatchConfigured"
              width="120px"
              :label="$t('text.payeeMatchConfigured')"
              align="center"
          >
            <template slot-scope="{ row }">
              <template v-if="row.productId === PAYMENT_TYPE_ID_COLLECTION">
                <el-tag v-if="row.payeeMatchConfigured" type="success" size="mini">
                  {{ $t('text.configured') }}
                </el-tag>
                <el-tag v-else type="info" size="mini">
                  {{ $t('text.notConfigured') }}
                </el-tag>
              </template>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="priority"
              width="70px"
              :label="$t('text.priority')"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="minAmount"
              width="120px"
              :label="$t('text.minAmount')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.minAmount">
                {{ $formatter.FenToYuanToThousandth(null, null, row.minAmount, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="maxAmount"
              width="120px"
              :label="$t('text.maxAmount')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.maxAmount">
                {{ $formatter.FenToYuanToThousandth(null, null, row.maxAmount, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="quota"
              width="120px"
              :label="$t('text.quota')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.quota">
                {{ $formatter.FenToYuanToThousandth(null, null, row.quota, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
              prop="alarmThresholdDay"
              width="120px"
              :label="$t('text.transactionAmountThreshold.Day')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.alarmThresholdDay">
                {{ $formatter.FenToYuanToThousandth(null, null, row.alarmThresholdDay, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>


          <el-table-column
              prop="alarmThresholdMonth"
              width="120px"
              :label="$t('text.transactionAmountThreshold.Month')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.alarmThresholdMonth">
                {{ $formatter.FenToYuanToThousandth(null, null, row.alarmThresholdMonth, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="alarmBalanceThreshold"
              width="110px"
              :label="$t('text.alarmBalanceThreshold')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.alarmBalanceThreshold">
                {{ row.alarmBalanceThreshold }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>
          <template v-if="this.$store.state.isPK">
            <el-table-column prop="iftFeeRate" :label="$t('text.iftFeeRate')" width="70px" align="center">
            </el-table-column>

            <el-table-column prop="ibftFeeRate" :label="$t('text.ibftFeeRate')" width="90px" align="center">
            </el-table-column>

            <el-table-column prop="channelAgentRate" :label="$t('text.channelAgentRate')" width="110px" align="center">
            </el-table-column>

            <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>
          </template>
          <el-table-column prop="upstreamView" :label="$t('text.upstream')" align="center" width="130px">
          </el-table-column>

          <el-table-column
              prop="balance"
              width="120px"
              :label="$t('text.balance')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.balance !== undefined && row.balance !== null">
                {{ $formatter.FenToYuanToThousandth(null, null, row.balance, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="balanceUpdateTime"
              :label="$t('text.balanceUpdateTime')"
              :formatter="$formatter.formatDate"
              width="150px"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="createTime"
              :label="$t('text.creationTime')"
              :formatter="$formatter.formatDate"
              width="150px"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="updateTime"
              :label="$t('text.updateTime')"
              width="150px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updateTime">
                {{ $formatter.formatDate(null, null, row.updateTime, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              fixed="right"
              :label="$t('text.actions')"
              width="280"
              align="center"
          >
            <template slot-scope="scope">
              <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="edit(scope.row)"
              >{{ $t('text.edit') }}
              </el-button>
              <el-button
                  type="success"
                  size="mini"
                  plain
                  @click="queryBalance(scope.row)"
              >{{ $t('text.balance') }}
              </el-button>
              <el-button
                  v-if="scope.row.productId === PAYMENT_TYPE_ID_COLLECTION"
                  type="warning"
                  size="mini"
                  plain
                  @click="openPayeeMatch(scope.row)"
              >{{ $t('text.payeeMatchConfig') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>

      <!--<DeviceAdd :show.sync="showDialog" :formData="formData" :action="action"></DeviceAdd>-->
      <!--<DevicePayType :show.sync="showSetPayDialog" :formData="formData" :action="action"></DevicePayType>-->

      <PkRouteChannelInfoEdit
          :show.sync="showDialog"
          :value="formData"
          :action="action"
          :channel-option="channelOption"
          :agentList="agentList"
          @refresh-agent-list="fetchAgentList"
          @created="onChannelCreated"
          v-if="this.$store.state.isPK"
      ></PkRouteChannelInfoEdit>

      <BdRouteChannelInfoEdit
          :show.sync="showDialog"
          :value="formData"
          :action="action"
          :channel-option="channelOption"
          :agentList="agentList"
          @refresh-agent-list="fetchAgentList"
          @created="onChannelCreated"
          v-if="this.$store.state.isBD"
      ></BdRouteChannelInfoEdit>

      <PayeeMatchConfigDialog
          :show.sync="showPayeeMatchDialog"
          :channel="payeeMatchChannel"
          :channel-options="payinChannelOptions"
          @saved="onPayeeMatchSaved"
      />

      <PayeeMatchConfigImportDialog
          :show.sync="showPayeeMatchImportDialog"
          @imported="onPayeeMatchImported"
      />

      <!-- Add wallet balance dialog -->
      <el-dialog
          :title="$t('text.walletBalance')"
          :visible.sync="showBalanceDialog"
          width="50%"
          :close-on-click-modal="false"
      >
        <el-table :data="walletBalanceList" border style="width: 100%">
          <el-table-column
              prop="walletType"
              :label="$t('text.walletType')"
              align="center"
          />
          <el-table-column
              prop="walletNumber"
              :label="$t('text.walletNumber')"
              align="center"
          />
          <el-table-column
              prop="balance"
              :label="$t('text.walletBalance')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.balance !== undefined && row.balance !== null">
                {{ $formatter.YuanToThousandth(null, null, row.balance, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="updatedAt"
              :label="$t('text.updateAt')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updatedAt">
                {{ $formatter.formatDate(null, null, row.updatedAt, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="exportWalletBalance">{{ $t('text.export') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import PkRouteChannelInfoEdit from "./routeChannelInfo/PkRouteChannelInfoEdit.vue";
import PayeeMatchConfigDialog from "./routeChannelInfo/PayeeMatchConfigDialog.vue";
import PayeeMatchConfigImportDialog from "./routeChannelInfo/PayeeMatchConfigImportDialog.vue";
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT, ROLE_TYPE
} from "@/utils/Constant";
import BdRouteChannelInfoEdit from "@/views/route/routeChannelInfo/BdRouteChannelInfoEdit.vue";
import * as XLSX from 'xlsx';

export default {
  name: "Systems",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
    PkRouteChannelInfoEdit: PkRouteChannelInfoEdit,
    BdRouteChannelInfoEdit: BdRouteChannelInfoEdit,
    PayeeMatchConfigDialog: PayeeMatchConfigDialog,
    PayeeMatchConfigImportDialog: PayeeMatchConfigImportDialog
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      url: "/routeChannelInfo/selectList",
      action: "",
      form: {
        channelId: "",
        productId: "",
        channelStatus: "00"
      },
      deviceToken: "",
      showDialog: false,
      showBalanceDialog: false,
      showPayeeMatchDialog: false,
      showPayeeMatchImportDialog: false,
      payeeMatchChannel: null,
      formData: null,
      showSetPayDialog: false,
      channelOption: [],
      payinChannelOptions: [],
      upstreamList: [],
      agentList: [],
      walletBalanceList: [],
    };
  },
  created() {
    // this.$axios
    //   .get("/productType/selectByProductType", { params: {} })
    //   .then((res) => {
    //     this.channelOption = res.data;
    //   });
    this.$axios
        .get("/order/orderPayment/selectPackagedUpstream", {params: {}})
        .then((res) => {
          this.upstreamList = res.data;
        });
    this.$axios.get("/channelAgent/list", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.agentList = res.data;
      }
    });
    this.$axios.get("/routeChannelInfo/selectListForOption", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.payinChannelOptions = (res.data || []).filter(item => String(item.productId) === "110");
      }
    });
  },
  methods: {
    edit(row) {
      const agent = this.agentList.find(agent => agent.agentId === row.channelAgentId);
      row.channelAgentName = agent ? agent.agentName : '';
      this.action = "edit";
      this.formData = row;
      this.showDialog = true;
    },
    openPayeeMatch(row) {
      this.payeeMatchChannel = row;
      this.showPayeeMatchDialog = true;
    },
    openPayeeMatchImport() {
      this.showPayeeMatchImportDialog = true;
    },
    onPayeeMatchImported() {
      // 导入结果弹窗内已展示；无需强制刷新列表
    },
    onPayeeMatchSaved() {
      this.$bus.$emit("refresh");
    },
    onChannelCreated(channel) {
      // 新增代收渠道后同步进入凭证设置（不强制必须保存，方便测试中渠道先建再配）
      if (!channel || String(channel.productId) !== String(PAYMENT_TYPE_ID_COLLECTION)) {
        return;
      }
      this.openPayeeMatch({
        channelId: channel.channelId,
        channelName: channel.channelName,
        productId: channel.productId
      });
    },
    add() {
      this.action = "add";
      this.showDialog = true;
    },
    queryBalance(row) {
      if (this.$store.state.isBD && !row.upstream.includes("route_setting")) {
        this.$axios.get("/routeChannelInfo/routeChannelInfoQueryWalletBalance", {
          params: {
            upstream: row.upstream,
            channelId: row.channelId
          }
        }).then((res) => {
          if (res.code === 200) {
            this.walletBalanceList = res.data.sort((a, b) => {
              const typeCompare = (a.walletType || '').localeCompare(b.walletType || '');
              if (typeCompare !== 0) return typeCompare;

              return (b.balance || 0) - (a.balance || 0);
            });
            this.showBalanceDialog = true;
          } else {
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: res.msg
            });
          }
        });
      } else {
        this.$axios.get("/routeChannelInfo/routeChannelInfoQueryBalance", {
          params: {
            channelId: row.channelId
          }
        }).then((res) => {
          if (res.code === 200) {
            this.$notify({
              title: this.$t('text.prompt'),
              message: res.msg,
              type: "success"
            });
            this.$bus.$emit("refresh");
          } else {
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: res.msg
            });
          }
        });
      }
    },
    fetchAgentList() {
      this.$axios.get("/channelAgent/list", { params: {} }).then((res) => {
        if (res.code === 200) {
          this.agentList = res.data;
        }
      });
    },
    exportWalletBalance() {
      if (!this.walletBalanceList || this.walletBalanceList.length === 0) {
        this.$notify.warning({
          title: this.$t('text.prompt'),
          message: this.$t('message.noDataToExport')
        });
        return;
      }

      // 准备Excel数据
      const headers = [
        this.$t('text.walletType'),
        this.$t('text.walletNumber'),
        this.$t('text.walletBalance'),
        this.$t('text.updateAt')
      ];

      const data = this.walletBalanceList.map(item => [
        item.walletType || '--',
        item.walletNumber || '--',
        item.balance !== undefined && item.balance !== null ? this.$formatter.YuanToThousandth(null, null, item.balance, null) : '--',
        item.updatedAt ? this.$formatter.formatDate(null, null, item.updatedAt, null) : '--'
      ]);

      // 创建工作簿
      const wb = XLSX.utils.book_new();

      // 创建工作表数据
      const ws_data = [headers, ...data];
      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      // 设置列宽
      const colWidths = [
        { wch: 15 }, // walletType
        { wch: 20 }, // walletNumber
        { wch: 15 }, // balance
        { wch: 20 }  // updateAt
      ];
      ws['!cols'] = colWidths;

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // 导出文件
      const fileName = this.$t('text.walletBalance') + ".xlsx";
      XLSX.writeFile(wb, fileName);
    },
  }
};
</script>

<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-popover pre {
  max-width: 800px;
  max-height: 500px;
  overflow: auto;
}
</style>
